import { format } from 'date-fns'

export const ASSISTANT_DEFAULT_VALUES = {
  name: '',
  slug: '',
  description: '',
  initialPrompt: '',
  tokenApi: '',
  temperature: 0,
  maxTokens: 0,
  frequencyPenalty: 0,
  presencePenalty: 0,
  reasoningEffort: '',
  service: '',
  model: '',
  isActive: false,
}

export const REASONING_EFFORT_OPTIONS = [
  { value: 'none', label: 'Nenhum' },
  { value: 'minimal', label: 'Mínimo' },
  { value: 'low', label: 'Baixo' },
  { value: 'medium', label: 'Médio' },
  { value: 'high', label: 'Alto' },
  { value: 'xhigh', label: 'Muito alto' },
]

export const AI_SERVICES = [
  { name: 'openai', desc: 'OpenAi/ChatGPT' },
  { name: 'openrouter', desc: 'OpenRouter' },
]

export const IaAssistantsColumns = styles => [
  {
    field: 'name',
    headerName: 'Assistente',
    width: 300,
    editable: false,
    cellClassName: styles.idColumn,
  },
  {
    field: 'model',
    headerName: 'Modelo de IA',
    width: 200,
    editable: false,
  },
  {
    field: 'createdAt',
    headerName: 'Data de criação',
    width: 200,
    editable: false,
    renderCell: params => {
      const date = new Date(params.value)
      return format(date, 'dd/MM/yyyy HH:mm')
    },
  },
  {
    field: 'modifiedBy',
    headerName: 'Usuário',
    width: 200,
    editable: false,
    renderCell: ({ value }) => value?.name,
  },
  {
    field: 'isActive',
    headerName: 'Ativo',
    width: 120,
    editable: false,
    renderCell: ({ value }) => (value ? 'Sim' : 'Não'),
  },
]
